/* ==========================================================================
   Second Coat — Page JS (Archive, Collection, Product)
   Upload to: Shopify Admin → Themes → Edit code → Assets
   Reference in theme.liquid before </body>:
     <script src="{{ 'second-coat-pages.js' | asset_url }}" defer></script>
   ========================================================================== */

(function () {
  'use strict';

  /* --------------------------------------------------------------------------
     Utilities
     -------------------------------------------------------------------------- */
  function pad(n) { return String(n).padStart(2, '0'); }
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  /* --------------------------------------------------------------------------
     Archive — Sticky tab bar + tab switching
     -------------------------------------------------------------------------- */
  function initArchiveTabs() {
    var detail = qs('.sc-archive-detail');
    if (!detail) return;

    var tabBar  = qs('.sc-archive-detail__tabs', detail);
    var tabs    = qsa('.sc-archive-detail__tab', detail);
    var panels  = qsa('.sc-archive-detail__panel', detail);

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-tab');
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var panel = document.getElementById('sc-tab-' + target);
        if (panel) panel.classList.add('is-active');
      });
    });

    /* Sticky shadow cue */
    if (tabBar) {
      var sentinel = document.createElement('div');
      sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:1px;pointer-events:none;';
      tabBar.parentNode.insertBefore(sentinel, tabBar);

      var obs = new IntersectionObserver(function (entries) {
        tabBar.classList.toggle('is-stuck', !entries[0].isIntersecting);
      }, { rootMargin: '-1px 0px 0px 0px', threshold: [1] });
      obs.observe(sentinel);
    }
  }

  /* --------------------------------------------------------------------------
     References — Full-screen board viewer
     -------------------------------------------------------------------------- */
  function initBoardViewer() {
    var openBtn  = qs('[data-open-board]');
    var viewer   = qs('[data-board-viewer]');
    var closeBtn = qs('[data-close-board]');
    if (!openBtn || !viewer) return;

    function open() {
      viewer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      viewer.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    viewer.addEventListener('click', function (e) {
      if (e.target === viewer) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* --------------------------------------------------------------------------
     Collection — Hover image slideshow + progress bar
     Only activates on non-touch devices (pointer: fine)
     -------------------------------------------------------------------------- */
  function initCollectionCards() {
    var isFine = window.matchMedia('(pointer: fine)').matches;

    qsa('[data-product-card]').forEach(function (card) {
      var wrap         = qs('.sc-product-card__image-wrap', card);
      var mainImg      = qs('.sc-product-card__image--active', card);
      var progressBar  = qs('.sc-product-card__progress', card);
      var fill         = qs('.sc-product-card__progress-fill', card);
      if (!wrap || !mainImg) return;

      var rawImages = (wrap.getAttribute('data-images') || '').split('|').filter(Boolean);
      if (!isFine || rawImages.length < 2) return;

      var frameDuration = 2600;
      var interval = null;
      var originalSrc = mainImg.src;
      var idx = 0;

      function advance() {
        idx = (idx + 1) % rawImages.length;
        mainImg.src = rawImages[idx];
        if (fill) fill.style.width = ((idx + 1) / rawImages.length * 100) + '%';
      }

      card.addEventListener('mouseenter', function () {
        idx = 0;
        mainImg.src = rawImages[0];
        if (fill) { fill.style.transition = 'none'; fill.style.width = (1 / rawImages.length * 100) + '%'; }
        if (progressBar) progressBar.style.opacity = '1';
        setTimeout(function () { if (fill) fill.style.transition = ''; }, 50);
        interval = setInterval(advance, frameDuration);
      });

      card.addEventListener('mouseleave', function () {
        clearInterval(interval);
        mainImg.src = originalSrc;
        if (fill) fill.style.width = '0%';
        if (progressBar) progressBar.style.opacity = '0';
      });
    });
  }

  /* --------------------------------------------------------------------------
     Product Gallery — Arrow navigation, keyboard, swipe, tracker
     -------------------------------------------------------------------------- */
  function initProductGallery() {
    var gallery = document.getElementById('sc-product-gallery');
    if (!gallery) return;

    var slides  = qsa('.sc-product-main__slide', gallery);
    var prevBtn = qs('.sc-product-main__arrow--prev', gallery);
    var nextBtn = qs('.sc-product-main__arrow--next', gallery);
    var fill    = qs('.sc-product-main__tracker-fill', gallery);
    var counter = qs('[data-gallery-counter]', gallery);
    var total   = slides.length;
    var current = 0;

    if (total === 0) return;

    function goTo(idx) {
      slides[current].classList.remove('is-active');
      current = (idx + total) % total;
      slides[current].classList.add('is-active');
      if (fill) fill.style.width = ((current + 1) / total * 100) + '%';
      if (counter) counter.textContent = pad(current + 1) + ' / ' + pad(total);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    /* Keyboard */
    gallery.setAttribute('tabindex', '0');
    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  goTo(current - 1);
      if (e.key === 'ArrowRight') goTo(current + 1);
    });

    /* Touch swipe */
    var touchX = 0;
    gallery.addEventListener('touchstart', function (e) {
      touchX = e.touches[0].clientX;
    }, { passive: true });
    gallery.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 44) goTo(dx < 0 ? current + 1 : current - 1);
    });

    goTo(0);
  }

  /* --------------------------------------------------------------------------
     Product — Variant / colour / size selection
     -------------------------------------------------------------------------- */
  function initVariantSelection() {
    var form        = document.getElementById('sc-product-form');
    if (!form) return;

    var variantInput  = qs('[data-variant-id]', form);
    var priceEl       = qs('[data-product-price]');
    var addBtn        = qs('[data-add-to-cart]');
    var colourLabel   = qs('[data-selected-colour]');
    var ctaWrap       = qs('[data-product-cta]');

    /* Size buttons */
    qsa('[data-size-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        qsa('[data-size-btn]').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');

        var variantId = btn.getAttribute('data-variant-id');
        var price     = btn.getAttribute('data-price');
        var available = btn.getAttribute('data-available') !== 'false';
        var status    = btn.getAttribute('data-status') || 'ready';

        if (variantInput) variantInput.value = variantId;
        if (priceEl && price) priceEl.textContent = price;

        if (addBtn) {
          addBtn.className = 'sc-product-main__btn sc-product-main__btn--primary';
          if (!available) {
            addBtn.textContent = 'SOLD OUT';
            addBtn.className = 'sc-product-main__btn sc-product-main__btn--sold';
            addBtn.disabled = true;
          } else if (status === 'preorder') {
            addBtn.textContent = 'PRE-ORDER';
            addBtn.className = 'sc-product-main__btn sc-product-main__btn--preorder';
            addBtn.disabled = false;
          } else {
            addBtn.textContent = 'ADD TO BAG';
            addBtn.disabled = false;
          }
        }
      });
    });

    /* Colour swatches — update image + label */
    qsa('[data-colour-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        qsa('[data-colour-btn]').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');

        var label = btn.getAttribute('data-colour');
        if (colourLabel) colourLabel.textContent = label;

        /* Update gallery to first image of this colour variant */
        var imgSrc = btn.getAttribute('data-variant-image');
        if (imgSrc) {
          var firstSlide = qs('.sc-product-main__slide.is-active img');
          if (firstSlide) firstSlide.src = imgSrc;
        }

        /* Deselect size when colour changes */
        qsa('[data-size-btn]').forEach(function (b) { b.classList.remove('is-selected'); });
        if (addBtn) {
          addBtn.textContent = 'SELECT SIZE';
          addBtn.className = 'sc-product-main__btn sc-product-main__btn--select';
          addBtn.disabled = true;
        }
      });
    });

    /* Add to cart */
    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        if (addBtn.disabled) { e.preventDefault(); return; }
        /* Check size is selected */
        var sizeSelected = qsa('[data-size-btn].is-selected').length > 0;
        var hasSizes = qsa('[data-size-btn]').length > 0;
        if (hasSizes && !sizeSelected) {
          e.preventDefault();
          addBtn.textContent = 'SELECT SIZE';
          addBtn.classList.add('sc-product-main__btn--select');
          return;
        }
        form.submit();
      });
    }
  }

  /* --------------------------------------------------------------------------
     Size Guide — CM / IN toggle
     -------------------------------------------------------------------------- */
  function initSizeGuide() {
    qsa('[data-size-guide]').forEach(function (guide) {
      var cmBtns = qsa('[data-unit-cm]', guide);
      var inBtns = qsa('[data-unit-in]', guide);
      var cmCells = qsa('[data-cm]', guide);
      var inCells = qsa('[data-in]', guide);

      function setUnit(unit) {
        qsa('[data-unit-cm], [data-unit-in]', guide).forEach(function (btn) {
          var isCm = btn.hasAttribute('data-unit-cm');
          btn.classList.toggle('is-active', unit === 'cm' ? isCm : !isCm);
        });
        cmCells.forEach(function (el) { el.style.display = unit === 'cm' ? '' : 'none'; });
        inCells.forEach(function (el) { el.style.display = unit === 'in' ? '' : 'none'; });
      }

      cmBtns.forEach(function (btn) { btn.addEventListener('click', function () { setUnit('cm'); }); });
      inBtns.forEach(function (btn) { btn.addEventListener('click', function () { setUnit('in'); }); });
      setUnit('cm');
    });
  }

  /* --------------------------------------------------------------------------
     Accordions — slide open/close
     -------------------------------------------------------------------------- */
  function initAccordions() {
    qsa('.sc-accordion').forEach(function (acc) {
      var trigger = qs('.sc-accordion__trigger', acc);
      var body    = qs('.sc-accordion__body', acc);
      if (!trigger || !body) return;

      trigger.addEventListener('click', function () {
        var isOpen = acc.classList.contains('is-open');
        /* Close all siblings */
        var parent = acc.parentNode;
        if (parent) {
          qsa('.sc-accordion', parent).forEach(function (a) {
            a.classList.remove('is-open');
          });
        }
        if (!isOpen) acc.classList.add('is-open');
      });
    });
  }

  /* --------------------------------------------------------------------------
     Size guide trigger inside purchase module
     -------------------------------------------------------------------------- */
  function initSizeGuideTrigger() {
    var trigger  = qs('[data-size-guide-trigger]');
    var accordion = qs('[data-accordion-id="size-guide"]');
    if (!trigger || !accordion) return;

    trigger.addEventListener('click', function () {
      accordion.classList.add('is-open');
      accordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* --------------------------------------------------------------------------
     Collection — View toggle (grid / editorial)
     -------------------------------------------------------------------------- */
  function initViewToggle() {
    var grid = qs('[data-collection-grid]');
    if (!grid) return;

    var btns = qsa('[data-view-btn]');
    if (!btns.length) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mode = btn.getAttribute('data-view-btn');
        btns.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        if (mode === 'editorial') {
          grid.setAttribute('data-view-mode', 'editorial');
        } else {
          grid.removeAttribute('data-view-mode');
        }
      });
    });
  }

  /* --------------------------------------------------------------------------
     Stock Indicator — update when a size variant is selected
     -------------------------------------------------------------------------- */
  function initStockIndicator() {
    var indicator = qs('[data-stock-indicator]');
    if (!indicator) return;

    var labelEl   = qs('[data-stock-label]',   indicator);
    var counterEl = qs('[data-stock-counter]',  indicator);
    var fillEl    = qs('[data-stock-fill]',     indicator);
    var stockMax  = parseInt(indicator.getAttribute('data-stock-max') || '20', 10);

    function update(qty, available) {
      var pct = Math.max(0, Math.min(100, qty / stockMax * 100));
      var isSoldOut  = !available || qty <= 0;
      var isLow      = !isSoldOut && qty <= 4;

      var label, barColor;
      if (isSoldOut) {
        label    = 'Sold Out';
        barColor = 'rgba(31,23,20,0.16)';
      } else if (isLow) {
        label    = qty + ' remaining \u2014 low stock';
        barColor = '#5B1A24';
      } else {
        label    = qty + ' of ' + stockMax + ' remaining';
        barColor = 'rgba(31,23,20,0.38)';
      }

      if (labelEl) {
        labelEl.textContent = label;
        labelEl.classList.toggle('is-low', isLow);
      }
      if (counterEl) {
        counterEl.style.display = isSoldOut ? 'none' : '';
        counterEl.textContent = pad(qty) + ' / ' + pad(stockMax);
      }
      if (fillEl) {
        fillEl.style.width    = pct + '%';
        fillEl.style.background = barColor;
      }
    }

    /* Listen for size button clicks and update the indicator */
    qsa('[data-size-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var qty       = parseInt(btn.getAttribute('data-stock') || '0', 10);
        var available = btn.getAttribute('data-available') !== 'false';
        update(qty, available);
      });
    });
  }

  /* --------------------------------------------------------------------------
     Boot — run everything on DOMContentLoaded
     -------------------------------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', function () {
    initArchiveTabs();
    initBoardViewer();
    initCollectionCards();
    initViewToggle();
    initProductGallery();
    initVariantSelection();
    initStockIndicator();
    initSizeGuide();
    initAccordions();
    initSizeGuideTrigger();
  });

})();
